exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.menusContainer[data-v-2758b01a] {\n  top:10%;\n  margin-left: 25px;\n  margin-top: auto;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2758b01a","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/menus/MobileMenuComponents/MobileMenuContainer.vue
// module id = 1553
// module chunks = 2